import React from 'react';
import styled from '@emotion/styled';
import { Text } from '@chakra-ui/react';
import { CancelCircleIcon } from 'static/icons';
import { PrimaryButton } from 'components';

const ContainerStyled = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
`;

const CancelCircleIconStyled = styled(CancelCircleIcon)`
  color: ${({ theme }) => theme.colors.highlight};
  margin-top: auto;
`;

export const CancellationSucceedPage: React.FC<{
  homeLink: string;
}> = ({ homeLink }) => {
  return (
    <ContainerStyled>
      <CancelCircleIconStyled />
      <Text color="black" textStyle="h2" mt="6">
        Ваша запись отменена
      </Text>
      <PrimaryButton
        as="a"
        href={homeLink}
        w="199px"
        mt="auto"
        mb={{ base: '74px', md: '143px' }}
      >
        Записаться еще
      </PrimaryButton>
    </ContainerStyled>
  );
};
